import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dealer, IDealerSlice } from 'interfaces/dealerLocator';
import { RootState } from 'redux/store';

const initialState: IDealerSlice = {
  selectedDealer: undefined,
  preferredDealerId: '',
};

export const dealerSlice = createSlice({
  name: 'dealer',
  initialState,
  reducers: {
    setSelectedDealer: (state, action: PayloadAction<Dealer | undefined>) => {
      state.selectedDealer = action.payload;
    },
    setPreferredDealerId: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.preferredDealerId = action.payload || '';
    },
    removePreferredDealerId: (state) => {
      state.preferredDealerId = '';
    },
    removeSelectedDealer: (state) => {
      state.selectedDealer = undefined;
    },
  },
});

export const {
  setSelectedDealer,
  removeSelectedDealer,
  setPreferredDealerId,
  removePreferredDealerId,
} = dealerSlice.actions;

export const selectedDealer = (state: RootState) => state.dealer.selectedDealer;
export const preferredDealer = (state: RootState) =>
  state.dealer.preferredDealerId;

export default dealerSlice.reducer;
